import { formatDateBySegment } from "../dates";

export const meterApiDataToBarChartData = (
  apiData: Array<Record<string, unknown>>,
  segment: string,
) => {
  const returnData: Array<Record<string, unknown>> = [];
  apiData.forEach((arrayItem: Record<string, unknown>) => {
    const label = formatDateBySegment((arrayItem as any).ts, segment);

    let subObj: Record<string, unknown> = {
      label: label,
    };
    subObj = {
      ...(arrayItem as Record<string, unknown>),
      ...subObj,
    };

    returnData.push(subObj);
  });

  return returnData;
};
